/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UsersListComp, Header, NewUserModal } from "../components";
import { NotificationModal } from "@vlinder-web/notification-modal-v2-widget-react";
import { routes } from "../../../services/appNavigatorService/config/routes.config.json";
import { Button, Modal } from "react-bootstrap";

import { Paginate } from "../../../widgets/paginate-widget-react-main/src/index";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";
import { AppNavigatorService, BlackListUserPageService } from "../../../services";
import { SearchFilter } from "../../../widgets/filter-widget-react";
import {
  useSMUsersListPageGetContent,
  useSMInviteUser,
  useSMDeleteUser,
  useSMReInviteUser,
  useSMSuspendUser,
  useSMActivateUser,
} from "../machines";
import { VApplication } from "../../../application";
import { SettingsComp } from "../components/Settings";

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BlackListUserPageService") as BlackListUserPageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const [showNoModal, setShowNoModal] = useState<boolean>(true);
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const history = useHistory();
  const srv = getSrv();
  const [role, setRole] = useState("");
  const appNavSrv = getAppNavService().whoAmI();
  appNavSrv
    .then((resolvedValue) => {
      const UserRole = resolvedValue.whoami;
      setRole(UserRole);
    })
    .catch((error) => {
      console.error(error);
    });
  useEffect(() => {
    srv?.resetCriteria();
  }, []);
  const { inviteUserMachine, inviteUserSend, inviteUserState } =
    useSMInviteUser({});
  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});

  const { deleteUserMachine, deleteUserSend, deleteUserState } =
    useSMDeleteUser({});

  const { suspendUserMachine, suspendUserSend, suspendUserState } =
    useSMSuspendUser({});

  const { reInviteUserMachine, reInviteUserSend, reInviteUserState } =
    useSMReInviteUser({});

  const { activateUserMachine, activateUserSend, activateUserState } =
    useSMActivateUser({});

  const onHeaderAction2Click = (id: string) => {
    console.log("import -- 22>");
    history.push("/bulk-user-list", { role: "Masquerader" });
  };
  const _onHeaderDDActionItemClick = (id: string) => {
    console.log("import -- >");
  };
  const onRefresh = (id: string) => {
    usersListPageSend("TRIGGER_REFRESH", {});
    setRefreshPagination(new Date());
  };
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };

  const deleteUser = (id: any) => {
    deleteUserSend("START", {
      payload: id,
    });
  };

  const onSuspendUsers = (ids: any) => {
    console.log("blacklisting", ids)
    // suspendUserSend("START", {
    //   payload: ids,
    // });
  };
  const onInviteUsers = (ids: any) => {
    inviteUserSend("START", {
      payload: ids,
    });
  };

  const onTogglePress = (
    key: string,
    item: { id: string; email: string; vuid: string }
  ) => {
    console.log(`onTogglePress :`, key, item);
    if (key === "view") {
      console.log(`onTogglePress :`);
      // props?.onTogglePress && props?.onTogglePress(item?.id);
      history.push({
        pathname: routes?.ViewBoxDetails?.path,
        state: { email: item },
      });
    }
    if (key === "suspend") {
      suspendUserSend("START", {
        payload: item?.email,
      });
    }
    if (key === "re-invite") {
      reInviteUserSend("START", {
        payload: item?.vuid,
      });
    }
    if (key === "whitelist") {
      activateUserSend("START", {
        payload: item?.email,
      });
    }
    // if (key === "suspend") {
    //   suspendUserSend("START", {
    //     payload: userId,
    //   });
    // }
    // if (key === "re-invite") {
    //   reInviteUserSend("START", {
    //     payload: userId,
    //   });
    // }
    // if (key === "activate") {
    //   activateUserSend("START", {
    //     payload: userId,
    //   });
    // }
  };

  const onApplyFilter = (data: any, status: string) => {
    let criteria = {};
    if (status) {
      criteria = {
        accountStatus__in: status,
        ...data,
      };
    } else {
      criteria = {
        ...data,
      };
    }

    console.log("onApplyFilter--> criteria:", data);
    usersListPageSend("TRIGGER_REFRESH", {
      criteria: criteria,
    });
  };

  const _renderNotifications = () => {
    if (inviteUserState?.matches("INVITE_USER_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.userInviteSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (deleteUserState?.matches("DELETE_USER_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.deleteUserSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (reInviteUserState?.matches("RE_INVITE_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.reInviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const _renderActiveErrorModals = () => {
    if (activateUserState?.matches("ACTIVATE_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.activateUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderSuspendErrorModals = () => {
    if (suspendUserState?.matches("SUSPEND_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.suspendUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderActiveModals = () => {
    if (activateUserState?.matches("ACTIVATE_USER_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.activateUserSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderSuspendModals = () => {
    if (suspendUserState?.matches("SUSPEND_USER_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.suspendUserSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (inviteUserState?.matches("INVITE_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.inviteUser || {})}
          description={[inviteUserState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (deleteUserState?.matches("DELETE_USER_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.deleteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (reInviteUserState?.matches("RE_INVITE_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.reinviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    usersListPageSend("TRIGGER_REFRESH", {});
    setRefreshPagination(new Date());
  };

  const onBlackListUser = (
    email: string,
    firstName: string,
    lastName: string,
    // invite: boolean,
    // role: string,
    // phone: string
  ) => {
    console.log(
      `on blacklist new user `,
      email,
      firstName,
      lastName,
      // invite,
      // role,
      // phone
    );
    setShowModal(false);
    suspendUserSend("START", {
      payload: {
        email: email,
        firstName: firstName,
        lastName: lastName,
        // invite: invite,
        // role: role,
        // phone: phone,
      },
    });
  };

  const newUserClick = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const _addNewUser = () => {
    if (showModal) {
      console.log("Show model");
      let availableRole = usersListPageState?.event?.data?.value?.availableRole;

      if (role !== "superAdmin") {
        availableRole = availableRole.filter((f?: any) => {
          return f.label !== "Super Admin";
        });
      }

      return (
        <NewUserModal
          showModal={showModal}
          onAcknowledgement={onBlackListUser}
          onDeny={onModalClose}
          roleOptions={staticPageContentConfig?.inviteUser?.roleOptions}
          fields={staticPageContentConfig?.formData?.fields}
          layout={staticPageContentConfig?.formData?.layout}
          validatorConfig={staticPageContentConfig?.formData?.validatorConfig}
          availableRole={availableRole}
        />
      );
    }
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onAddUser}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  
  const onPageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    usersListPageSend("TRIGGER_REFRESH", {
            offset: 0,
      size: newPageSize,
    });
    setRefreshPagination(new Date());
  };
const onPaginationChange = (event: any) => {
    usersListPageSend("TRIGGER_REFRESH", {
      offset: event?.selected * pageSize,
      size: pageSize,
    });
  };

  const _renderPagination = () => {
    console.log(
      "pagination in userlist===",
      usersListPageState?.event?.data?.value
    );
    return (
      <Paginate
        {...(usersListPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        key={refreshPagination}
        pageSizeOptions={[10, 20, 50]}
        onPageSizeChange={onPageSizeChange}
      />
    );
  };

  const _renderPage = () => {
    if (
      inviteUserState?.matches("INVITE_USER") ||
      reInviteUserState?.matches("RE_INVITE")
    ) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.inviteUser || {})} />
      );
    }
    if (
      suspendUserState?.matches("SUSPEND_USER") ||
      activateUserState?.matches("ACTIVATE_USER")
    ) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.suspendUser || {})} />
      );
    }

    if (deleteUserState?.matches("DELETE_USER")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.deleteUser || {})} />
      );
    }

    if (usersListPageState?.matches("RENDER_PAGE")) {
      return (
        <>
          {usersListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(usersListPageState?.event?.data?.value || {})}
              deleteItems={deleteUser}
              suspendItems={onSuspendUsers}
              inviteUsers={onInviteUsers}
              onTogglePress={onTogglePress}
              onRowClick={props?.onRowClick && props?.onRowClick}
              ultDeleteUser={deleteUser}
              ultInviteUser={onInviteUsers}
              ultSuspendUser={onSuspendUsers}
            />
          )}
        </>
      );
    }
    if (usersListPageState?.matches("GET_PAGE_CONTENT")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return null;
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_addNewUser()}
      {_renderPagination()}
      {_renderNotifications()}
      {_renderErrorModals()}
      {_renderSuspendModals()}
      {_renderActiveModals()}
      {_renderSuspendErrorModals()}
      {_renderActiveErrorModals()}
      <div style={{ height: "150px" }}></div>
    </div>
  );
};
